<app-alert [alertType]="'success'" (closeClick)="closeClick.emit()">
  <span [innerHTML]="successText"></span>
  @if (redirectAction) {
    <span class="cursor-pointer font-bold underline" [innerHTML]="actionText" (click)="actionClicked()"></span>
  }
</app-alert>
